import { render, staticRenderFns } from "./MessageDetailAccordion.vue?vue&type=template&id=3360d467&lang=pug"
import script from "./MessageDetailAccordion.vue?vue&type=script&lang=ts"
export * from "./MessageDetailAccordion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports